module.exports = __webpack_public_path__ + "static/media/American Fats and Oils Association Logo.0417e767.png";